import React, { createContext, useState, useEffect } from 'react';

export const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
  const [currentOrder, setCurrentOrder] = useState({
    customer: null,
    items: [],
    addon: 0,
    deliveryCharge: 0,
    discount: 0,
    deliveryOption: 'standard',
    notes: ''
  });

  const addItem = (service, quantity, itemDetails) => {
    setCurrentOrder(prev => {
      const existingItemIndex = prev.items.findIndex(
        item => item.service._id === service._id
      );

      if (existingItemIndex > -1) {
        const updatedItems = [...prev.items];
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          quantity: updatedItems[existingItemIndex].quantity + quantity
        };
        return { ...prev, items: updatedItems };
      }

      return {
        ...prev,
        items: [...prev.items, { service, quantity, itemDetails }]
      };
    });
  };

  const updateItemQuantity = (serviceId, newQuantity) => {
    if (newQuantity <= 0) {
      removeItem(serviceId);
      return;
    }

    setCurrentOrder(prev => ({
      ...prev,
      items: prev.items.map(item =>
        item.service._id === serviceId
          ? { ...item, quantity: newQuantity }
          : item
      )
    }));
  };

  // ADD THIS FUNCTION
  const updateItemDetails = (serviceId, newDetails) => {
    setCurrentOrder(prev => ({
      ...prev,
      items: prev.items.map(item =>
        item.service._id === serviceId
          ? { ...item, itemDetails: newDetails }
          : item
      )
    }));
  };

  const removeItem = (serviceId) => {
    setCurrentOrder(prev => ({
      ...prev,
      items: prev.items.filter(item => item.service._id !== serviceId)
    }));
  };

  const setCustomer = (customer) => {
    setCurrentOrder(prev => ({ ...prev, customer }));
  };

  const setDiscount = (discount) => {
    setCurrentOrder(prev => ({ ...prev, discount }));
  };

  const setAddon = (addon) => {
    setCurrentOrder(prev => ({ ...prev, addon }));
  };

  const setDeliveryCharge = (deliveryCharge) => {
    setCurrentOrder(prev => ({ ...prev, deliveryCharge }));
  };

  const setDeliveryOption = (option) => {
    setCurrentOrder(prev => ({ ...prev, deliveryOption: option }));
  };

  const setNotes = (notes) => {
    setCurrentOrder(prev => ({ ...prev, notes }));
  };

  const clearOrder = () => {
    setCurrentOrder({
      customer: null,
      items: [],
      addon: 0,
      deliveryCharge: 0,
      discount: 0,
      deliveryOption: 'standard',
      notes: ''
    });
  };

  const calculateTotal = () => {
    const subtotal = currentOrder.items.reduce((sum, item) => {
      const itemTotal = item.service.price * item.quantity;
      const tax = (itemTotal * (item.service.taxPercentage || 0)) / 100;
      return sum + itemTotal + tax;
    }, 0);

    const total = subtotal + 
                  (currentOrder.addon || 0) + 
                  (currentOrder.deliveryCharge || 0) - 
                  (currentOrder.discount || 0);

    return { subtotal, total };
  };

  const value = {
    currentOrder,
    addItem,
    updateItemQuantity,
    updateItemDetails,  // MAKE SURE THIS IS INCLUDED
    removeItem,
    setCustomer,
    setDiscount,
    setAddon,
    setDeliveryCharge,
    setDeliveryOption,
    setNotes,
    clearOrder,
    calculateTotal
  };

  return (
    <OrderContext.Provider value={value}>
      {children}
    </OrderContext.Provider>
  );
};
